import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { PageChangedEvent } from 'ngx-bootstrap/pagination';
import { ListFilter } from '../../../types';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss'],
})
export class PaginatorComponent {
  @Input() filter!: ListFilter;
  @Input() total!: number;
  @Input() userTable? = false;
  @Output() filterApply = new EventEmitter<void>();

  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  changePageSize(event: Event): void {
    const selectedSize = parseInt(
      (event.target as HTMLSelectElement).value,
      10
    );
    this.pageSize = selectedSize || 10;
    this.filter.size = this.pageSize;

    // Defer to next macrotask so bindings update before we reset the page and emit;
    // avoids change-detection errors when the size changes.
    setTimeout(() => {
      this.filter.page = 1;
      this.currentPage = 0;
      this.filterApply.emit();
    });
  }

  get currentPage(): number {
    return (this.filter.page ?? 0) + 1;
  }

  set currentPage(value: number) {
    this.filter.page = value - 1;
  }

  onPageChanged(event: PageChangedEvent): void {
    const newPage = event.page - 1;
    const newSize = event.itemsPerPage;

    const changedPage = newPage !== this.filter.page;
    const changedSize = newSize !== this.filter.size;

    if (changedSize) {
      this.filter.size = newSize;
      this.filter.page = 0;
      this.filterApply.emit();
    } else if (changedPage) {
      this.filter.page = newPage;
      this.filterApply.emit();
    }
  }
}
